import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import React from "react";
var __jsx = React.createElement;
import CloseSVG from "../../../../../../../../SVGObjects/CloseSVG";
import DeleteSVG from "../../../../../../../../SVGObjects/DeleteSVG";
import DocumentSVG from "../../../../../../../../SVGObjects/DocumentSVG";
import UploadSVG from "../../../../../../../../SVGObjects/UploadSVG";
import Button from "../../../../../../../../components/UiKit/Button/Button";
import stl from "./FilePreview.module.css";
import { trackEvents } from "@/common/events/events";
import { useTranslation } from "@i18n";
import { Position, SpecialZoomLevel, TextDirection, Viewer, ViewMode, Worker } from '@react-pdf-viewer/core';
import useIsMobile from "@hooks/useIsMobile";
import useWebView from "@hooks/useWebview";
var PDF_JS_VERSION = '3.11.174';
var createPdfUrl = function createPdfUrl(val) {
  var _val$file;
  if (val !== null && val !== void 0 && (_val$file = val.file) !== null && _val$file !== void 0 && _val$file.startsWith('http')) {
    return val.file;
  }
  return URL.createObjectURL(new Blob([val]));
};
var PdfViewer = function PdfViewer(_ref) {
  var fileUrl = _ref.fileUrl;
  var isMobile = useIsMobile();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Worker, {
    workerUrl: "https://unpkg.com/pdfjs-dist@".concat(PDF_JS_VERSION, "/build/pdf.worker.min.js")
  }, /*#__PURE__*/React.createElement(Viewer, {
    viewMode: ViewMode.SinglePage,
    initialPage: 1
    //scrollMode={ScrollMode.Vertical}
    ,
    position: Position.TopCenter,
    defaultScale: isMobile ? SpecialZoomLevel.PageFit : SpecialZoomLevel.ActualSize,
    fileUrl: fileUrl,
    theme: {
      direction: TextDirection.LeftToRight
    }
  })));
};
var ImgPreview = function ImgPreview(_ref2) {
  var imageUrl = _ref2.imageUrl;
  return /*#__PURE__*/React.createElement("div", {
    className: stl.imageContainer
  }, /*#__PURE__*/React.createElement("img", {
    src: imageUrl,
    alt: "Uploaded",
    style: {
      maxWidth: "100%"
    }
  }));
};
var FilePreview = function FilePreview(_ref3) {
  var _domFileOrDbFile$type;
  var domInMemoryFile = _ref3.domInMemoryFile,
    dbFile = _ref3.dbFile,
    onClose = _ref3.onClose,
    setShowDeletePopup = _ref3.setShowDeletePopup,
    stepStatus = _ref3.stepStatus,
    hideButtons = _ref3.hideButtons,
    orginalInput = _ref3.orginalInput,
    g4_data = _ref3.g4_data;
  var webview = useWebView();
  var domFileOrDbFile = domInMemoryFile || dbFile;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.filePreviewContainer,
    onClick: function onClick(e) {
      if (e.target === e.currentTarget) {
        onClose();
        document.body.style.overflow = "";
      }
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.headContainer
  }, /*#__PURE__*/React.createElement(CloseSVG, {
    onClick: onClose
  }), /*#__PURE__*/React.createElement("p", null, domFileOrDbFile === null || domFileOrDbFile === void 0 ? void 0 : domFileOrDbFile.name)), /*#__PURE__*/React.createElement("div", {
    className: stl.contentContainer
  }, /*#__PURE__*/React.createElement(React.Fragment, null, (dbFile === null || dbFile === void 0 ? void 0 : dbFile.file) && /*#__PURE__*/React.createElement(ImgPreview, {
    imageUrl: dbFile === null || dbFile === void 0 ? void 0 : dbFile.file
  }), (domFileOrDbFile === null || domFileOrDbFile === void 0 ? void 0 : (_domFileOrDbFile$type = domFileOrDbFile.type) === null || _domFileOrDbFile$type === void 0 ? void 0 : _domFileOrDbFile$type.includes("image")) && /*#__PURE__*/React.createElement(ImgPreview, {
    imageUrl: URL.createObjectURL(domFileOrDbFile)
  }), (domFileOrDbFile === null || domFileOrDbFile === void 0 ? void 0 : domFileOrDbFile.type) === "application/pdf" && /*#__PURE__*/React.createElement(PdfViewer, {
    fileUrl: createPdfUrl(domFileOrDbFile)
  })), /*#__PURE__*/React.createElement("div", {
    className: "".concat(stl.buttonsContainer, " ").concat(!domFileOrDbFile.file ? stl.customOneButton : "", " ").concat(stepStatus === "approved" || stepStatus === "pending" || hideButtons ? stl.customButton : "")
  }, hideButtons ? "" : (stepStatus === "unaddressed" || stepStatus === "rejected") && /*#__PURE__*/React.createElement("div", {
    className: "".concat(stl.flex, " ").concat(!(domFileOrDbFile !== null && domFileOrDbFile !== void 0 && domFileOrDbFile.file) ? stl.OneButton : "")
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      orginalInput.click();
    },
    className: stl.transButton
  }, /*#__PURE__*/React.createElement(UploadSVG, {
    className: stl.gap
  }), " ", t("reload", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      setShowDeletePopup(true);
    },
    className: stl.redButton
  }, /*#__PURE__*/React.createElement(DeleteSVG, {
    className: stl.gap
  }), " ", t("delete_document", {
    ns: "web_tracking"
  }))), domFileOrDbFile.file && /*#__PURE__*/React.createElement("a", {
    href: "/download?url=".concat(domFileOrDbFile.file ? encodeURIComponent(domFileOrDbFile.file) : URL.createObjectURL(domFileOrDbFile)),
    rel: "noopener noreferrer",
    target: "_blank",
    download: true
  }, /*#__PURE__*/React.createElement(Button, {
    className: stl.whtButton,
    onClick: function onClick() {
      trackEvents("order_document_download", _objectSpread(_objectSpread({}, g4_data), {}, {
        document_id_type: domFileOrDbFile === null || domFileOrDbFile === void 0 ? void 0 : domFileOrDbFile.document_key
      }));
      if (domFileOrDbFile.file) {
        webview.openFile(domFileOrDbFile.file)["catch"](function (error) {
          document.location = "/download?url=".concat(encodeURIComponent(domFileOrDbFile.file));
        })["finally"](onClose);
      } else {
        onClose();
      }
    }
  }, /*#__PURE__*/React.createElement(DocumentSVG, {
    className: stl.gap
  }), " ", t("download_document_2", {
    ns: "web_tracking"
  })))))));
};
export default FilePreview;